<template>
  <div>
    <el-form :inline="true" :model="queryFormModel" class="demo-form-inline" size="small">
      <el-form-item label="名称">
        <el-input v-model="queryFormModel.keyword" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="应用">
        <el-select v-model="queryFormModel.appId" placeholder="请选择" clearable>
          <el-option v-for="item in appList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryList">查 询</el-button>
      </el-form-item>
    </el-form>

    <el-pagination
      style="margin-bottom: 5px; float: right;"
      background
      layout="prev, pager, next"
      :current-page.sync="page"
      :page-size.sync="rows"
      :total="tableTotal"
      @current-change="currentPageChanged">
    </el-pagination>

    <el-table ref="merchantTable" :data="tableData" :height="tableHeight" size="small" border style="width: 100%">
      <el-table-column prop="id" label="ID" width="200"></el-table-column>
      <el-table-column prop="appName" label="所属应用" width="200"></el-table-column>
      <el-table-column prop="name" label="名称"> </el-table-column>
      <el-table-column prop="pluPrefix" label="条码标识" width="100"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="200">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showDetailDialog(scope.row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="商户详情" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-descriptions :column="1" border>
        <el-descriptions-item label="ID">{{ entity.id }}</el-descriptions-item>
        <el-descriptions-item label="所属应用">{{ entity.appName }}</el-descriptions-item>
        <el-descriptions-item label="名称">{{ entity.name }}</el-descriptions-item>
        <el-descriptions-item label="条码标识">{{ entity.pluPrefix }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ entity.createTime }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import httpClient from '../httpClient.js'
export default {
  name: "MerchantList",
  data() {
    return {
      page: 1,
      rows: 20,
      tableTotal: 0,
      tableData: [],
      tableHeight: 400,
      appList: [],
      queryFormModel: {},
      dialogVisible: false,
      entity: {}
    };
  },
  methods: {
    queryList() {
      let data = {
        page: this.page,
        rows: this.rows,
        params: this.queryFormModel
      }
      httpClient.post("/api/merchant/query", data).then((response) => {
        this.tableTotal = response.data.data.total
        this.tableData = response.data.data.list
      })
    },
    queryAllAppList() {
      let params = {};
      httpClient.post("/api/app/query", params).then((response) => {
        this.appList = response.data.data.list
      })
    },
    calcTableHeight() {
      this.$nextTick(() => {
        const tableEl = this.$refs.merchantTable && this.$refs.merchantTable.$el
        // 以表格顶部到视口顶部的实际距离计算高度：整页不溢出、仅表格内部滚动
        const top = tableEl ? tableEl.getBoundingClientRect().top : 200
        this.tableHeight = Math.max(300, window.innerHeight - top - 30)
      })
    },
    currentPageChanged() {
      this.queryList()
    },
    showDetailDialog(row) {
      httpClient.get(`/api/merchant/${row.id}`).then((response) => {
        this.entity = response.data.data
        this.dialogVisible = true
      })
    },
    handleClose() {
      this.dialogVisible = false
    }
  },
  mounted() {
    this.queryList()
    this.queryAllAppList()
    this.calcTableHeight()
    window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcTableHeight)
  },
};
</script>
